import { render, staticRenderFns } from "./FiveAvatars.vue?vue&type=template&id=c205dc92&scoped=true"
import script from "./FiveAvatars.vue?vue&type=script&lang=js"
export * from "./FiveAvatars.vue?vue&type=script&lang=js"
import style0 from "./FiveAvatars.vue?vue&type=style&index=0&id=c205dc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c205dc92",
  null
  
)

export default component.exports